import { useNavigate, useRoutes } from "react-router-dom";
import MainRoutes from "./mainRoutes";
import { useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { clearLocalStorageKeepDrafts, getLogoutPath } from "@/utils/common";

export default function AppLayout() {

  const navigate = useNavigate();

  const { getRemainingTime } = useIdleTimer({
    timeout: import.meta.env.APP_IDLE_TIMEOUT_MINUTE * 60 * 1000,
    debounce: 1000,
    crossTab: true,
    stopOnIdle: true
  });
  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = getRemainingTime();
      if (remainingTime <= 0) {
        clearLocalStorageKeepDrafts();
        sessionStorage.clear()
        navigate(getLogoutPath());

      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };


  }, [getRemainingTime]);


  return useRoutes([MainRoutes])
}
